import { createSlice } from "@reduxjs/toolkit";
import { formatDate } from "../utils/formatDate";
import { setNameDay } from "../utils/setDateNames";

export const scheduleSlice = createSlice({
  name: 'schedule',
  initialState: {
    schedules: [],
    loading: false,
    maxDate: null,
    available: []
  },
  reducers: {
    loadingSchedules: (state) => {
      state.loading = true
    },
    setSchedules: (state, { payload }) => {
      state.loading = false;
      state.schedules = payload.map(item => {
        return {
          ...item,
          day: setNameDay(item.date)
        }
      })
      state.maxDate = payload[payload.length - 1].date
    },
    schedulesAvailables: (state, {payload}) => {
      const newDate = formatDate(payload)
      state.available = state.schedules.filter(item => item.date === newDate)
    },
    // selectSchedule
  }
})

export const { setSchedules, schedulesAvailables, loadingSchedules } = scheduleSlice.actions